function createChunkDecoder() {
  const decoder = new TextDecoder();

  return function (chunk) {
    if (!chunk) return "";
    return decoder.decode(chunk, { stream: true });
  };
}

export default async function streamedResponse(
  response,
  { abortController, onStreamMessage },
) {
  const reader = response.body.getReader();
  const decode = createChunkDecoder();

  let streamedResponse = "";

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    streamedResponse += decode(value).replace(/{{ping}}/g, "");
    onStreamMessage(streamedResponse);

    if (abortController?.() === null) {
      reader.cancel();
      break;
    }
  }

  return streamedResponse;
}
